import { createRedesignEntry } from "../redesign-page-entry";

/**
 * `plainSurface`: the one screen whose frames put their cards straight on the warm canvas instead of the
 * shell's white content card. This belongs on the entry so the Suspense fallback shares the ground
 * and the page does not flash white while its chunk downloads.
 *
 * `tightFooter`: pack the page to fit a real 13" window — the Figma frame is 884 tall and browser chrome
 * usually leaves less.
 */
export default createRedesignEntry(() => import("./dashboard-page"), {
  testId: "rd-dashboard-loading",
  shell: { activeNav: "achievements", plainSurface: true, tightFooter: true },
});
